import { useState, useEffect, useMemo } from 'react';
import './Dashboard.css';

const AUTH_KEY = 'mn_aff_authed';
const WALLET_KEY = 'mn_aff_wallet';
const VALID_LOGIN = 'porndude';
const VALID_PASSWORD = '1234';

const AFFILIATE_ID = 'mn_pd_01';
const REFERRAL_LINK = 'https://makeporn.art/?ref=porndude';
const COMMISSION_RATE = 30;

const KPI = {
    visits: 0,
    signups: 0,
    paying: 0,
    revenue: 0,
    earnings: 0,
    paidOut: 0,
    available: 0,
};

const DAILY_EARNINGS = Array(30).fill(0);

const ACTIVITY = [];
const PAYOUTS = [];

const NETWORKS = [
    { id: 'USDT_TRC20', label: 'USDT · TRC20', placeholder: 'T...' },
    { id: 'USDT_ERC20', label: 'USDT · ERC20', placeholder: '0x...' },
    { id: 'BTC',        label: 'Bitcoin',      placeholder: 'bc1q...' },
    { id: 'ETH',        label: 'Ethereum',     placeholder: '0x...' },
];

function fmtMoney(n) {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
function fmtInt(n) {
    return n.toLocaleString('en-US');
}

function SectionHead({ no, title, right }) {
    return (
        <div className="affEyebrow">
            <span className="affEyebrowNo">№ {no}</span>
            <span className="affEyebrowTitle">{title}</span>
            {right && <span className="affEyebrowRight">{right}</span>}
        </div>
    );
}

function LoginCard({ onSuccess }) {
    const [login, setLogin] = useState('');
    const [pwd, setPwd] = useState('');
    const [err, setErr] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        setErr('');
        setLoading(true);
        setTimeout(() => {
            if (login.trim() === VALID_LOGIN && pwd === VALID_PASSWORD) {
                try { localStorage.setItem(AUTH_KEY, '1'); } catch {}
                onSuccess();
            } else {
                setErr('Invalid login or code');
                setLoading(false);
            }
        }, 350);
    };

    return (
        <div className="affLoginWrap">
            <form className="affLoginCard" onSubmit={submit}>
                <span className="affKicker">№ 00 / Partner access</span>
                <h1 className="affLoginTitle">
                    Sign in to your<br />
                    <span className="affLoginTitleAccent">partner dashboard.</span>
                </h1>
                <p className="affLoginSub">Affiliate access only · Need credentials? Talk to your manager.</p>

                <label className="affField">
                    <span>Login</span>
                    <input
                        type="text"
                        autoComplete="username"
                        autoFocus
                        value={login}
                        onChange={(e) => setLogin(e.target.value)}
                        placeholder="your login"
                    />
                </label>

                <label className="affField">
                    <span>Code</span>
                    <input
                        type="password"
                        autoComplete="current-password"
                        value={pwd}
                        onChange={(e) => setPwd(e.target.value)}
                        placeholder="••••"
                    />
                </label>

                {err && <div className="affLoginErr">{err}</div>}

                <button type="submit" className="affBtnPrimary affBtnBlock" disabled={loading}>
                    {loading ? 'Checking…' : 'Sign in →'}
                </button>
            </form>
        </div>
    );
}

function ReferralLink() {
    const [copied, setCopied] = useState(false);
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(REFERRAL_LINK);
            setCopied(true);
            setTimeout(() => setCopied(false), 1600);
        } catch {}
    };
    return (
        <div className="affBox affBox--accent">
            <div className="affBoxHead">
                <div>
                    <div className="affBoxKicker">Your link</div>
                    <div className="affBoxTitle">Share & earn {COMMISSION_RATE}% on every sale</div>
                </div>
                <span className="affTag">ID · {AFFILIATE_ID}</span>
            </div>
            <div className="affLinkRow">
                <input className="affLinkInput" value={REFERRAL_LINK} readOnly onFocus={(e) => e.target.select()} />
                <button className="affBtnPrimary" onClick={copy}>
                    {copied ? 'Copied ✓' : 'Copy link'}
                </button>
            </div>
        </div>
    );
}

function StatCell({ no, label, value, sub, accent = false }) {
    return (
        <div className={`affStat${accent ? ' affStat--accent' : ''}`}>
            <div className="affStatTop">
                <span className="affStatNo">{no}</span>
                <span className="affStatLabel">{label}</span>
            </div>
            <div className="affStatValue">{value}</div>
            {sub && <div className="affStatSub">{sub}</div>}
        </div>
    );
}

function EarningsChart({ data }) {
    const max = Math.max(...data);
    const total = data.reduce((a, b) => a + b, 0);
    const isEmpty = max <= 0;

    return (
        <div className="affBox">
            <div className="affBoxHead">
                <div>
                    <div className="affBoxKicker">Last 30 days</div>
                    <div className="affBoxTitle">Daily earnings</div>
                </div>
                <div className="affChartTotal">
                    <span className="affChartTotalLabel">Total</span>
                    <span className="affChartTotalValue">{fmtMoney(total)}</span>
                </div>
            </div>
            {isEmpty ? (
                <div className="affChartEmpty">
                    <div className="affChartBaseline" aria-hidden />
                    <span>No earnings yet — share your link to get started.</span>
                </div>
            ) : (
                <div className="affChartBars" style={{ '--bars': data.length }}>
                    {data.map((v, i) => (
                        <div
                            key={i}
                            className="affBar"
                            style={{ '--h': `${(v / max) * 100}%` }}
                            title={`Day ${i + 1}: ${fmtMoney(v)}`}
                        />
                    ))}
                </div>
            )}
            <div className="affChartAxis">
                <span>30d ago</span>
                <span>15d</span>
                <span>today</span>
            </div>
        </div>
    );
}

function BalanceCard() {
    const canPayout = KPI.available >= 100;
    return (
        <div className="affBox affBox--accent">
            <div className="affBoxKicker">Available balance</div>
            <div className="affBalanceAmount">{fmtMoney(KPI.available)}</div>
            <div className="affBalanceMeta">
                <div className="affBalanceRow">
                    <span>Lifetime earned</span>
                    <strong>{fmtMoney(KPI.earnings)}</strong>
                </div>
                <div className="affBalanceRow">
                    <span>Paid out</span>
                    <strong>{fmtMoney(KPI.paidOut)}</strong>
                </div>
                <div className="affBalanceRow">
                    <span>Next payout</span>
                    <strong>—</strong>
                </div>
            </div>
            <button className="affBtnPrimary affBtnBlock" disabled={!canPayout}>
                Request payout →
            </button>
            <div className="affBoxNote">
                Min. payout $100 · Processed within 24h
            </div>
        </div>
    );
}

function WalletCard() {
    const [network, setNetwork] = useState('USDT_TRC20');
    const [address, setAddress] = useState('');
    const [saved, setSaved] = useState(false);
    const [hasSaved, setHasSaved] = useState(false);

    useEffect(() => {
        try {
            const raw = localStorage.getItem(WALLET_KEY);
            if (raw) {
                const w = JSON.parse(raw);
                if (w?.network) setNetwork(w.network);
                if (w?.address) setAddress(w.address);
                setHasSaved(true);
            }
        } catch {}
    }, []);

    const onSave = (e) => {
        e.preventDefault();
        if (!address.trim()) return;
        try {
            localStorage.setItem(WALLET_KEY, JSON.stringify({ network, address: address.trim() }));
            setHasSaved(true);
            setSaved(true);
            setTimeout(() => setSaved(false), 1800);
        } catch {}
    };

    const onClear = () => {
        try { localStorage.removeItem(WALLET_KEY); } catch {}
        setAddress('');
        setHasSaved(false);
    };

    const net = NETWORKS.find(n => n.id === network) || NETWORKS[0];

    return (
        <div className="affBox">
            <div className="affBoxHead">
                <div>
                    <div className="affBoxKicker">Withdrawal wallet</div>
                    <div className="affBoxTitle">Where we send the money</div>
                </div>
                {hasSaved && <span className="affTag affTag--ok">Saved</span>}
            </div>

            <form className="affWalletForm" onSubmit={onSave}>
                <label className="affField">
                    <span>Network</span>
                    <div className="affSelectWrap">
                        <select value={network} onChange={(e) => setNetwork(e.target.value)}>
                            {NETWORKS.map(n => <option key={n.id} value={n.id}>{n.label}</option>)}
                        </select>
                    </div>
                </label>

                <label className="affField">
                    <span>Wallet address</span>
                    <input
                        type="text"
                        spellCheck={false}
                        autoCapitalize="off"
                        autoCorrect="off"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder={net.placeholder}
                    />
                </label>

                <div className="affWalletActions">
                    <button type="submit" className="affBtnPrimary" disabled={!address.trim()}>
                        {saved ? 'Saved ✓' : 'Save wallet'}
                    </button>
                    {hasSaved && (
                        <button type="button" className="affBtnGhost" onClick={onClear}>
                            Remove
                        </button>
                    )}
                </div>

                <div className="affBoxNote">
                    Double-check the network — funds sent to a wrong network can't be recovered.
                </div>
            </form>
        </div>
    );
}

function ActivityTable() {
    return (
        <div className="affBox affBox--flat">
            {ACTIVITY.length === 0 ? (
                <div className="affEmpty">
                    Nothing yet. The moment someone clicks your link or signs up,<br/>
                    they'll show up here.
                </div>
            ) : (
                <div className="affTableWrap">
                    <table className="affTable">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Country</th>
                                <th>Event</th>
                                <th>Plan</th>
                                <th className="affTrRight">Your cut</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ACTIVITY.map((a, i) => (
                                <tr key={i}>
                                    <td>{a.date}</td>
                                    <td>{a.flag} {a.country}</td>
                                    <td>{a.event}</td>
                                    <td>{a.plan}</td>
                                    <td className="affTrRight affMono">{a.earn ? <span className="affEarn">+{fmtMoney(a.earn)}</span> : <span className="affMuted">—</span>}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

function PayoutHistory() {
    return (
        <div className="affBox affBox--flat">
            {PAYOUTS.length === 0 ? (
                <div className="affEmpty">
                    No payouts yet. Once your balance reaches $100,<br/>
                    you can request your first payout.
                </div>
            ) : (
                <div className="affTableWrap">
                    <table className="affTable">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Network</th>
                                <th>Tx</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {PAYOUTS.map((p, i) => (
                                <tr key={i}>
                                    <td>{p.date}</td>
                                    <td className="affMono">{fmtMoney(p.amount)}</td>
                                    <td>{p.network}</td>
                                    <td className="affMono affMuted">{p.tx}</td>
                                    <td><span className="affTag affTag--ok">{p.status}</span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

function DashboardView() {
    const conv = useMemo(() => ({
        signup: KPI.visits ? ((KPI.signups / KPI.visits) * 100).toFixed(1) : '0.0',
        paid: KPI.signups ? ((KPI.paying / KPI.signups) * 100).toFixed(1) : '0.0',
    }), []);

    return (
        <main className="affSection">
            {/* Hero / greeting */}
            <section className="affHero">
                <span className="affKicker affKicker--hero">Partner · {AFFILIATE_ID}</span>
                <h1 className="affTitle">
                    Welcome, partner.<br />
                    <span className="affTitleAccent">Get paid.</span>
                </h1>
                <p className="affSub">
                    Share your link · Earn {COMMISSION_RATE}% of every sale · Forever
                </p>
            </section>

            {/* Compliance-style ribbon → today's quick fact */}
            <div className="affRibbon">
                <span className="affRibbonDot">●</span>
                <span className="affRibbonText">
                    <strong>{COMMISSION_RATE}% revshare.</strong> Lifetime. Paid in crypto, every week over $100.
                </span>
                <span className="affRibbonRight">No clawbacks</span>
            </div>

            {/* 01 — Referral link */}
            <SectionHead no="01" title="Your referral link" />
            <ReferralLink />

            {/* 02 — Performance */}
            <SectionHead no="02" title="Performance" right="Last 30 days" />
            <div className="affStatsGrid">
                <StatCell no="01" label="Visits"       value={fmtInt(KPI.visits)}    sub="unique clicks" />
                <StatCell no="02" label="Sign-ups"     value={fmtInt(KPI.signups)}   sub={`${conv.signup}% from visits`} />
                <StatCell no="03" label="Paying"       value={fmtInt(KPI.paying)}    sub={`${conv.paid}% from sign-ups`} />
                <StatCell no="04" label="Revenue"      value={fmtMoney(KPI.revenue)} sub="gross sales" />
                <StatCell no="05" label="Your earnings" value={fmtMoney(KPI.earnings)} sub={`${COMMISSION_RATE}% commission`} accent />
            </div>

            <EarningsChart data={DAILY_EARNINGS} />

            {/* 03 — Money */}
            <SectionHead no="03" title="Balance & withdrawals" />
            <div className="affRow affRow--moneySplit">
                <BalanceCard />
                <WalletCard />
            </div>

            {/* 04 — Activity */}
            <SectionHead no="04" title="Recent activity" right="Live" />
            <ActivityTable />

            {/* 05 — Payouts */}
            <SectionHead no="05" title="Payout history" right="All time" />
            <PayoutHistory />

            <p className="affFootnote">
                Numbers update once per day · Questions?{' '}
                <a href="mailto:partners@makeporn.art">partners@makeporn.art</a>
            </p>
        </main>
    );
}

export function Dashboard() {
    const [authed, setAuthed] = useState(() => {
        try { return localStorage.getItem(AUTH_KEY) === '1'; } catch { return false; }
    });

    const logout = () => {
        try { localStorage.removeItem(AUTH_KEY); } catch {}
        setAuthed(false);
    };

    return (
        <div className="affPage">
            <header className="affTopbar">
                <div className="affTopbarInner">
                    <div className="affLogo">
                        Make<span className="affLogoAccent">porn</span>
                        <span className="affLogoTag">partners</span>
                    </div>
                    {authed && (
                        <button className="affBtnGhost affBtnGhost--sm" onClick={logout}>
                            Sign out
                        </button>
                    )}
                </div>
            </header>

            {authed
                ? <DashboardView />
                : <LoginCard onSuccess={() => setAuthed(true)} />
            }
        </div>
    );
}
